
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[business]/access/[category]",
      function () {
        return require("private-next-pages/[lang]/[business]/access/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[business]/access/[category]"])
      });
    }
  